import Skeleton from '@/shared/Loaders/Skeleton'
import css from './skeletonEventCell.module.css'

const SkeletonEventCell = () => {
  return (
    <div className={css.wrapper}>
      <div className="flex-lines gap4" style={{ alignItems: 'start' }}>
        <Skeleton style={{ borderRadius: '4px' }} height="22px" width="110px" />
      </div>
      <div className="flex-lines gap4" style={{ height: 'fit-content', width: '100%' }}>
        <Skeleton style={{ borderRadius: '4px', maxWidth: '340px' }} height="18px" width="100%" />
        <Skeleton style={{ borderRadius: '4px', maxWidth: '250px' }} height="18px" width="75%" />
      </div>
    </div>
  )
}

export default SkeletonEventCell
